import { EventNameTypes, makeSegmentTrackCall } from './analytics';

function trackPhoneNumberClick(event) {
  const phoneNumber = event.target.href.replace(/^tel:/, '');
  const props = {
    phonenameclick: 'Yes',
    phonenamenumber: phoneNumber
  };

  if (window.clientSideInjectionVars.market) {
    props.phonenamemarket = window.clientSideInjectionVars.market.name;
  }

  makeSegmentTrackCall(EventNameTypes.interaction, props);
}

export function addTrackPhoneNumberClickEvents() {
  const phoneNumbersElements = document.querySelectorAll('a[href^="tel:"]');

  Array.from(phoneNumbersElements).forEach(el => {
    el.addEventListener('click', trackPhoneNumberClick);
  });
}
